<template>

  <div :id="_uid" class="ui small modal" :class="modalSelector">
    <div class="ui header">
      {{ isCreating ? "Adicionar Serviço" : "Alterar Serviço" }}
    </div>
    <div class="content">
      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div class="ten wide field">
            <label class="form-label">Serviço <span class="red text">*</span></label>
            <select-dropdown ref="serviceDropdown" @onChange="onChangeService" />
          </div>
          <div class="six wide field">
            <label class="form-label">Tipo <span class="red text">*</span></label>
            <select-dropdown ref="typeDropdown" @onChange="onChangeServiceType" />
          </div>
        </div>        
        <div class="fields">
          <div class="five wide field">
            <label class="form-label">Valor <span class="red text">*</span></label>
            <input class="money" :value="serviceValue" @blur="serviceValue = $event.target.value">
          </div>
          <div class="five wide field">
            <label class="form-label">Valor em Dinheiro</label>
            <input class="money" :value="moneyValue" @blur="moneyValue = $event.target.value">
          </div>  
          <div class="five wide field">
            <label class="form-label">Repasse</label>
            <input class="money" :value="paybackValue" @blur="paybackValue = $event.target.value">
          </div>  
        </div>
        <div class="fields">
          <div class="five wide field">
            <label class="form-label">Antecipação Crédito</label>
            <input class="money" :value="creditAnticipationValue" @blur="creditAnticipationValue = $event.target.value">
          </div>
          <div class="five wide field">
            <label class="form-label">Antecipação Débito</label>
            <input class="money" :value="debitAnticipationValue" @blur="debitAnticipationValue = $event.target.value">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>            
      <button class="ui blue button" :class="{ disabled: !canConfirm }" @click="onConfirm()">
        <i class="checkmark icon"></i>
        {{ isCreating ? "Confirmar" : "Atualizar" }}
      </button>
    </div>
  </div>  

</template>

<script>

  import _ from "underscore"
  import modalDialog from "@/mixins/modal-dialog"
  import SelectDropdown from "@/components/select-dropdown"
  import Input from "@/utils/input"
  import SrvService from "@/services/srv-service"

  export default {

    name: "CustomerServiceFormModal",

    mixins: [modalDialog],
    
    data() {
      return {
        serviceList: [],
        service: {},
        srvService: new SrvService(),
      }
    },

    components: {
      SelectDropdown,
    },

    mounted() {
      Input.maskCurrency()
      this.loadServiceList()
    },

    computed: {

      serviceValue: {
        get() {
          return Input.currencyToString(this.service.value)
        },
        set(value) {
          this.service.value = Input.stringToCurrency(value)    
          this.refreshData()   
        },
      },

       moneyValue: {
        get() {
          return Input.currencyToString(this.service.moneyValue)
        },
        set(value) {
          this.service.moneyValue = Input.stringToCurrency(value)    
          this.refreshData()   
        },
      },

      paybackValue: {
        get() {
          return Input.currencyToString(this.service.payback)
        },
        set(value) {
          this.service.payback = Input.stringToCurrency(value)    
          this.refreshData()   
        },
      },

      creditAnticipationValue: {
        get() {
          return Input.currencyToString(this.service.creditAnticipation)
        },
        set(value) {
          this.service.creditAnticipation = Input.stringToCurrency(value)    
          this.refreshData()   
        },
      },

      debitAnticipationValue: {
        get() {
          return Input.currencyToString(this.service.debitAnticipation)
        },
        set(value) {
          this.service.debitAnticipation = Input.stringToCurrency(value)    
          this.refreshData()   
        },
      },

      canConfirm() {
        return (this.service.serviceId && this.service.serviceTypeId && this.service.value)
      },
    },

    methods: {

      async loadServiceList() {

        this.loading = true

        try {

          this.serviceList = await this.srvService.findAll()          
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      load(service) {
        
        this.loading = true
        this.service = {}

        if (service) {
          this.service = this.$cloneObject(service)
          this.service.service = this.serviceList.find((srv) => srv.id == service.serviceId)
        }  

        this.$refs.serviceDropdown.setValues(this.serviceList, this.service.serviceId)  

        this.loadServiceTypes()

        this.show()

        this.loading = false
      },

      onChangeService(id) {

        if (this.loading)
          return

        this.service.serviceTypeId = null
        this.service.serviceType = null
        this.service.serviceId = id ? parseInt(id) : null
        this.service.service = this.serviceList.find((srv) => srv.id == id)

        this.loadServiceTypes()
        this.refreshData()
      },

      loadServiceTypes() {

        if (!this.service.serviceId)
          return

        let types = []
        let serviceTypes = _.sortBy(this.service.service.types, "description")
        let icon = ""

        for (const type of serviceTypes) {
          icon = `<i class="${SrvService.TYPE_ICONS[type.icon].icon} m-r-5"></i>`
          types.push({
            id: type.id,
            description: `${icon} ${type.description}`,
          })
        }

        this.$refs.typeDropdown.setValues(types, this.service.serviceTypeId)
      },

      onChangeServiceType(id) {
        
        if (this.loading)
          return

        this.service.serviceTypeId = id ? parseInt(id) : null
        this.service.serviceType = this.service.service.types.find((type) => type.id == id)

        this.refreshData()
      },

      refreshData() {
        this.service = this.$cloneObject(this.service)
      },

      onConfirm() {

        const event = this.isCreating ? "onCreate" : "onUpdate"

        this.emit(event, this.$cloneObject(this.service))
      },
    },
  }

</script>